<template>
  <div class="market">
    <div class="market__header">
      <el-menu
        :default-active="this.index.toString()"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#051922"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="0">精选</el-menu-item>
        <el-menu-item index="1">系统插件</el-menu-item>
        <el-menu-item index="2">流程工具</el-menu-item>
        <el-menu-item index="3">应用平台</el-menu-item>
        <el-menu-item index="4">教学指南</el-menu-item>
<!--        <el-menu-item index="98">入驻须知</el-menu-item>-->
        <el-menu-item index="99">FAQ</el-menu-item>
      </el-menu>
    </div>
    <div class="market__title">{{ this.indexName }}</div>
    <div class="market__search">
      <el-input placeholder="请输入关键词查询"
                @keyup.enter.native="handelSearch"
                v-model="value">
        <el-button type="primary"
                   slot="append"
                   @click="handelSearch">查询
        </el-button>
        <el-button type="primary"
                   slot="append"
                   @click="handelReset">重置
        </el-button>
      </el-input>
    </div>
    <div class="market__content" v-if="!validatenull(baseList)">
      <el-card class="market__text" shadow="hover"
               v-for="(obj,index) in baseList"
               :key="index">
        <div @click="open(obj)">
          <img :src="obj.src" alt="">
          <p style="font-size: 20px;">{{ obj.name }}</p>
          <p style="font-size: 15px; color: #c1c1c1">{{ obj.desc }}</p>
          <p style="font-size: 16px; color: #de5052">¥ {{ obj.price }}</p>
        </div>

      </el-card>
    </div>
  </div>
</template>

<script>
import list from '@/const/marketlist'

export default {
  data() {
    return {
      index: 0,
      indexName: '精选',
      value: '',
      baseList: [],
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.index = Number(this.$route.query.version)
      if (!this.index) this.index = 0
      if (this.index === 0) {
        this.indexName = '精选';
      } else if (this.index === 1) {
        this.indexName = '系统插件';
      } else if (this.index === 2) {
        this.indexName = '流程工具';
      } else if (this.index === 3) {
        this.indexName = '应用平台';
      } else if (this.index === 4) {
        this.indexName = '教学指南';
      }
      if (this.index === 0) {
        this.baseList = list.filter(item => item.recommend === true && item.show !== false);
      } else {
        this.getList();
      }
    },
    open(obj) {
      if (obj.href) {
        window.open(obj.href);
        return false;
      } else if (obj.path) {
        this.$router.push(`/market${obj.path}`);
      }
    },
    handleSelect(key) {
      this.index = Number(key);
      if (this.index === 0) {
        this.indexName = '精选';
        this.$router.push('/market?version=0');
      } else if (this.index === 1) {
        this.indexName = '系统插件';
        this.$router.push('/market?version=1');
      } else if (this.index === 2) {
        this.indexName = '流程工具';
        this.$router.push('/market?version=2');
      } else if (this.index === 3) {
        this.indexName = '应用平台';
        this.$router.push('/market?version=3');
      }  else if (this.index === 4) {
        this.indexName = '教学指南';
        this.$router.push('/market?version=4');
      } else if (this.index === 98) {
        this.$router.push('/market/notice');
        return;
      } else if (this.index === 99) {
        this.$router.push('/market/faq');
        return;
      }
      this.getList();
    },
    handelSearch() {
      this.getList();
    },
    handelReset() {
      this.value = '';
      this.handelSearch();
    },
    getList() {
      if (this.validatenull(this.value)) {
        this.baseList = list.filter(item => (this.index === 0) ? item.recommend === true && item.show !== false : item.index === this.index && item.show !== false);
      } else {
        this.baseList = list.filter(
          item =>
            (
              (this.index === 0) ? item.recommend === true && item.show !== false : item.index === this.index && item.show !== false
            )
            && item.name.includes(this.value)
        );
      }
    }
  }
};
</script>

<style lang="scss">
.market {
  padding-top: 60px;
  min-height: 500px;
  height: auto;

  &__header {
    width: 100%;
  }

  &__title {
    width: 100%;
    font-size: 38px;
    text-align: center;
    font-weight: 600;
    padding-top: 20px;
  }

  &__search {
    width: 600px;
    margin: 25px auto 0 auto;
  }

  &__content {
    width: 100%;
    margin: 30px 0;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    justify-content: center;
  }

  &__text {
    box-sizing: border-box;
    margin: 15px 10px 0 10px;
    width: 20%;
    cursor: pointer;

    p {
      margin-top: 1rem;
      margin-bottom: 0;
      line-height: 30px;
    }
  }
}
</style>
